import holidaysList from '../../data/holidays.json';

export function findHolidayName(date: string) {
  const f = holidaysList.find((h) => h.date.startsWith(date));
  return f?.description ?? '';
}
